import { render, staticRenderFns } from "./PlacesControls.vue?vue&type=template&id=25bfc0fc&scoped=true&"
import script from "./PlacesControls.vue?vue&type=script&lang=js&"
export * from "./PlacesControls.vue?vue&type=script&lang=js&"
import style0 from "./PlacesControls.vue?vue&type=style&index=0&id=25bfc0fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfc0fc",
  null
  
)

export default component.exports